import { z } from "zod";

export const ProjetoInformacoesSchema = z.object({
  idInformacoes: z.number().nullable().optional(),
  idProjeto: z.coerce.number().nullable().optional(),
  descInformacoes: z.string().nullable().optional(),
  idFuncionario: z.coerce.number().nullable().optional(),
  data: z.coerce.date().nullable().optional(),
});

export type ProjetoInformacoesForm = z.infer<typeof ProjetoInformacoesSchema>;
